import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {Grid} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";
import {useI18N} from "../../../common/common";
import CustomButton from "../../widget/button/CustomButton";
import {hexToRgb} from "../../../common/theme";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
    marketPlaceImg: {
        marginTop: theme.spacing(5),
        [theme.breakpoints.up("sm")]: {
            width: theme.spacing(12.5),
            marginRight: theme.spacing(3),
            marginTop: theme.spacing(3)
        },
    },
    marketPlaceTutorialContent: {
        height: "fit-content",
        marginLeft: theme.spacing(1),
        [theme.breakpoints.up("sm")]: {
            maxWidth: theme.spacing(43)
        }
    },
    marketPlaceTutorialTitle: {
        textAlign: "left",
        fontSize: theme.spacing(3.5),
        color: hexToRgb(theme.palette.black, theme.palette.textOpacity.textHigh),
        [theme.breakpoints.up("sm")]: {
            textAlign: "left",
            fontSize: theme.spacing(3),
        }
    },
    marketPlaceDescription: {
        flex: 1,
        color: hexToRgb(theme.palette.black, theme.palette.textOpacity.textHigh)
    },
    marketPlaceButton: {
        borderRadius: theme.spacing(3),
        border: "1px solid " + theme.palette.secondary["900"],
        color: theme.palette.secondary["900"],
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        "&:hover": {
            borderRadius: theme.spacing(3),
            backgroundColor: "#E8E6E3 !important"
        },
        [theme.breakpoints.up("sm")]: {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
        }
    },
    mb2: {
        marginBottom: theme.spacing(2)
    },
}));


const HeaderPopoverTutorial = ({openDialog}) => {
    const classes = useStyles();
    const {i18n} = useI18N();

    return (
        <>
            <Grid
                container
                direction="row"
            >
                <Grid
                    item
                    xs={4}
                    md={3}
                >
                    <img
                        src={"/images/Onboarding_marketplace.svg"}
                        alt="What's new image"
                        className={classes.marketPlaceImg}
                    />
                </Grid>
                <Grid
                    item
                    xs={8}
                    md={9}
                >
                    <Grid
                        container
                        direction="column"
                        className={classes.marketPlaceTutorialContent}
                    >
                        <Grid item>
                            <Typography
                                variant="h4"
                                className={clsx(classes.marketPlaceTutorialTitle, classes.mb2)}
                            >{i18n("view.header.marketplace_onboarding.title")}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography
                                variant="body1"
                                className={clsx(classes.marketPlaceDescription, classes.mb2)}
                            >
                                {i18n("view.header.marketplace_onboarding.description")}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <CustomButton
                                className={classes.marketPlaceButton}
                                disableRipple
                                size={"small"}
                                onClick={openDialog}
                            >
                                {i18n("view.header.marketplace_onboarding.popover_button")}
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};

HeaderPopoverTutorial.propTypes = {
    openDialog: PropTypes.func,
};

export default HeaderPopoverTutorial;
